export default "__VITE_ASSET__DajxayIu__"